import React from "react";
import { Zap, Github, Twitter, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-32 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <Zap className="w-5 h-5 text-[#FF007F]" />
            <span className="font-display font-black text-xl">GLOW<span className="text-[#FF007F]">CART</span></span>
          </div>
          <p className="text-sm text-zinc-500 max-w-sm leading-relaxed">
            A marketplace where artists, makers, and brands shine. Upload your products, set your price, glow louder.
          </p>
          <div className="flex gap-4 mt-6 text-zinc-500">
            <Twitter className="w-4 h-4 hover:text-[#05D9E8] cursor-pointer" />
            <Instagram className="w-4 h-4 hover:text-[#FF007F] cursor-pointer" />
            <Github className="w-4 h-4 hover:text-white cursor-pointer" />
          </div>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] text-zinc-600 mb-4">Marketplace</p>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li>Browse</li><li>Categories</li><li>Featured</li><li>New Drops</li>
          </ul>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] text-zinc-600 mb-4">Sellers</p>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li>Start Selling</li><li>Listing Fees</li><li>Pro Subscription</li><li>Seller Guide</li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/5 flex justify-between text-xs text-zinc-600">
        <span>© 2026 GlowCart.art · All glow reserved.</span>
        <span className="font-display tracking-widest">GLOWCART.ART</span>
      </div>
    </footer>
  );
}
